module.exports = __webpack_public_path__ + "img/symbol_5.c3b48b77.png";